module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@tkey/common-types");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("bip39");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("hdkey");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("bn.js");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("web3-utils");

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = require("web3-eth");

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "SeedPhraseError", function() { return /* reexport */ errors; });
__webpack_require__.d(__webpack_exports__, "MetamaskSeedPhraseFormat", function() { return /* reexport */ src_MetamaskSeedPhraseFormat; });
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ SeedPhrase; });
__webpack_require__.d(__webpack_exports__, "SEED_PHRASE_MODULE_NAME", function() { return /* reexport */ SEED_PHRASE_MODULE_NAME; });
__webpack_require__.d(__webpack_exports__, "SeedPhraseModule", function() { return /* reexport */ SeedPhrase; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(3);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(4);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/assertThisInitialized"
var assertThisInitialized_ = __webpack_require__(6);
var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(10);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(11);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(8);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@tkey/common-types"
var common_types_ = __webpack_require__(5);

// CONCATENATED MODULE: ./src/errors.ts








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf_default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf_default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn_default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var errors_SeedPhraseError = /*#__PURE__*/function (_TkeyError) {
  inherits_default()(SeedPhraseError, _TkeyError);

  var _super = _createSuper(SeedPhraseError);

  function SeedPhraseError(code, message) {
    var _this;

    classCallCheck_default()(this, SeedPhraseError);

    // takes care of stack and proto
    _this = _super.call(this, code, message); // Set name explicitly as minification can mangle class names

    defineProperty_default()(assertThisInitialized_default()(_this), "code", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "message", void 0);

    Object.defineProperty(assertThisInitialized_default()(_this), "name", {
      value: "SeedPhraseError"
    });
    return _this;
  }

  createClass_default()(SeedPhraseError, null, [{
    key: "fromCode",
    value: function fromCode(code) {
      var extraMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new SeedPhraseError(code, "".concat(SeedPhraseError.messages[code]).concat(extraMessage));
    } // Custom methods

  }, {
    key: "notSupported",
    value: function notSupported() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return SeedPhraseError.fromCode(6010, extraMessage);
    }
  }, {
    key: "validationFailed",
    value: function validationFailed() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return SeedPhraseError.fromCode(6011, extraMessage);
    }
  }, {
    key: "invalid",
    value: function invalid() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return SeedPhraseError.fromCode(6012, extraMessage);
    }
  }]);

  return SeedPhraseError;
}(common_types_["TkeyError"]);

defineProperty_default()(errors_SeedPhraseError, "messages", {
  6000: "Custom",
  // Misc
  6010: "Private key type is not supported",
  6011: "validation failed",
  6012: "Seed phrase is invalid for "
});

/* harmony default export */ var errors = (errors_SeedPhraseError);
// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(0);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "bip39"
var external_bip39_ = __webpack_require__(7);

// EXTERNAL MODULE: external "bn.js"
var external_bn_js_ = __webpack_require__(12);
var external_bn_js_default = /*#__PURE__*/__webpack_require__.n(external_bn_js_);

// EXTERNAL MODULE: external "hdkey"
var external_hdkey_ = __webpack_require__(9);
var external_hdkey_default = /*#__PURE__*/__webpack_require__.n(external_hdkey_);

// EXTERNAL MODULE: external "web3-utils"
var external_web3_utils_ = __webpack_require__(13);

// EXTERNAL MODULE: external "web3-eth"
var external_web3_eth_ = __webpack_require__(14);
var external_web3_eth_default = /*#__PURE__*/__webpack_require__.n(external_web3_eth_);

// CONCATENATED MODULE: ./src/web3.ts
 // Because web3-eth typings are wrong

/* harmony default export */ var src_web3 = (external_web3_eth_default.a);
// CONCATENATED MODULE: ./src/MetamaskSeedPhraseFormat.ts












var MetamaskSeedPhraseFormat_MetamaskSeedPhraseFormat = /*#__PURE__*/function () {
  function MetamaskSeedPhraseFormat(ethProvider) {
    classCallCheck_default()(this, MetamaskSeedPhraseFormat);

    defineProperty_default()(this, "type", void 0);

    defineProperty_default()(this, "hdPathString", void 0);

    defineProperty_default()(this, "provider", void 0);

    defineProperty_default()(this, "root", void 0);

    this.hdPathString = "m/44'/60'/0'/0";
    this.type = "HD Key Tree";
    this.provider = ethProvider;
  } // eslint-disable-next-line class-methods-use-this


  createClass_default()(MetamaskSeedPhraseFormat, [{
    key: "validateSeedPhrase",
    value: function validateSeedPhrase(seedPhrase) {
      var _trim$toLowerCase$mat;

      var parsedSeedPhrase = ((_trim$toLowerCase$mat = (seedPhrase || "").trim().toLowerCase().match(/[0-9A-Z_a-z]+/g)) === null || _trim$toLowerCase$mat === void 0 ? void 0 : _trim$toLowerCase$mat.join(" ")) || "";
      var wordCount = parsedSeedPhrase.split(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/).length;

      if (wordCount % 3 !== 0 || wordCount > 24 || wordCount < 12) {
        return false;
      }

      return Object(external_bip39_["validateMnemonic"])(seedPhrase);
    }
  }, {
    key: "deriveKeysFromSeedPhrase",
    value: function () {
      var _deriveKeysFromSeedPhrase = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(seedPhraseStore) {
        var mmStore, seedPhrase, seed, hdkey, root, numOfWallets, wallets, i, child, wallet;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mmStore = seedPhraseStore;
                seedPhrase = mmStore.seedPhrase;
                _context.next = 4;
                return Object(external_bip39_["mnemonicToSeed"])(seedPhrase);

              case 4:
                seed = _context.sent;
                hdkey = external_hdkey_default.a.fromMasterSeed(seed);
                root = hdkey.derive(this.hdPathString);
                numOfWallets = mmStore.numberOfWallets;
                wallets = [];

                for (i = 0; i < numOfWallets; i += 1) {
                  child = root.deriveChild(i);
                  wallet = new external_bn_js_default.a(child.privateKey);
                  wallets.push(wallet);
                }

                return _context.abrupt("return", wallets);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function deriveKeysFromSeedPhrase(_x) {
        return _deriveKeysFromSeedPhrase.apply(this, arguments);
      }

      return deriveKeysFromSeedPhrase;
    }()
  }, {
    key: "createSeedPhraseStore",
    value: function () {
      var _createSeedPhraseStore = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(seedPhrase) {
        var numberOfWallets, finalSeedPhrase, lastBalance, web3, hdkey, root, wallet, address;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                numberOfWallets = 0;
                finalSeedPhrase = seedPhrase || Object(external_bip39_["generateMnemonic"])();
                web3 = new src_web3(this.provider);
                hdkey = external_hdkey_default.a.fromMasterSeed(finalSeedPhrase);
                root = hdkey.derive(this.hdPathString); // seek out the first zero balance

              case 5:
                if (!(lastBalance !== "0")) {
                  _context2.next = 15;
                  break;
                }

                wallet = root.deriveChild(numberOfWallets);
                address = Object(common_types_["generateAddressFromPublicKey"])(wallet.publicKey); // eslint-disable-next-line no-await-in-loop

                _context2.next = 10;
                return web3.getBalance(address);

              case 10:
                lastBalance = _context2.sent;
                lastBalance = Object(external_web3_utils_["fromWei"])(lastBalance);
                numberOfWallets += 1;
                _context2.next = 5;
                break;

              case 15:
                return _context2.abrupt("return", {
                  id: Object(common_types_["generateID"])(),
                  type: this.type,
                  seedPhrase: finalSeedPhrase,
                  numberOfWallets: numberOfWallets
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createSeedPhraseStore(_x2) {
        return _createSeedPhraseStore.apply(this, arguments);
      }

      return createSeedPhraseStore;
    }()
  }]);

  return MetamaskSeedPhraseFormat;
}();

/* harmony default export */ var src_MetamaskSeedPhraseFormat = (MetamaskSeedPhraseFormat_MetamaskSeedPhraseFormat);
// CONCATENATED MODULE: ./src/SeedPhrase.ts





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var SEED_PHRASE_MODULE_NAME = "seedPhraseModule";

var SeedPhrase_SeedPhraseModule = /*#__PURE__*/function () {
  function SeedPhraseModule(formats) {
    classCallCheck_default()(this, SeedPhraseModule);

    defineProperty_default()(this, "moduleName", void 0);

    defineProperty_default()(this, "tbSDK", void 0);

    defineProperty_default()(this, "seedPhraseFormats", void 0);

    this.moduleName = SEED_PHRASE_MODULE_NAME;
    this.seedPhraseFormats = formats;
  }

  createClass_default()(SeedPhraseModule, [{
    key: "setModuleReferences",
    value: function setModuleReferences(tbSDK) {
      this.tbSDK = tbSDK;
      this.tbSDK.addReconstructKeyMiddleware(this.moduleName, this.getAccounts.bind(this));
    } // eslint-disable-next-line

  }, {
    key: "initialize",
    value: function () {
      var _initialize = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "setSeedPhrase",
    value: function () {
      var _setSeedPhrase = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(seedPhraseType, seedPhrase) {
        var format, seedPhraseStore;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                format = this.seedPhraseFormats.find(function (el) {
                  return el.type === seedPhraseType;
                });

                if (format) {
                  _context2.next = 3;
                  break;
                }

                throw errors.notSupported();

              case 3:
                if (!(seedPhrase && !format.validateSeedPhrase(seedPhrase))) {
                  _context2.next = 5;
                  break;
                }

                throw errors.invalid("".concat(seedPhraseType));

              case 5:
                _context2.next = 7;
                return format.createSeedPhraseStore(seedPhrase);

              case 7:
                seedPhraseStore = _context2.sent;
                return _context2.abrupt("return", this.tbSDK.setTKeyStoreItem(this.moduleName, seedPhraseStore, true));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setSeedPhrase(_x, _x2) {
        return _setSeedPhrase.apply(this, arguments);
      }

      return setSeedPhrase;
    }()
  }, {
    key: "setSeedPhraseStoreItem",
    value: function () {
      var _setSeedPhraseStoreItem = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(partialStore) {
        var seedPhraseItem, originalItem, finalItem;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.tbSDK.getTKeyStoreItem(this.moduleName, partialStore.id);

              case 2:
                seedPhraseItem = _context3.sent;
                originalItem = {
                  id: seedPhraseItem.id,
                  type: seedPhraseItem.type,
                  seedPhrase: seedPhraseItem.seedPhrase
                }; // Disallow editing critical fields

                finalItem = _objectSpread(_objectSpread({}, partialStore), originalItem);
                return _context3.abrupt("return", this.tbSDK.setTKeyStoreItem(this.moduleName, finalItem, true));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setSeedPhraseStoreItem(_x3) {
        return _setSeedPhraseStoreItem.apply(this, arguments);
      }

      return setSeedPhraseStoreItem;
    }()
  }, {
    key: "getSeedPhrases",
    value: function () {
      var _getSeedPhrases = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.tbSDK.getTKeyStore(this.moduleName));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getSeedPhrases() {
        return _getSeedPhrases.apply(this, arguments);
      }

      return getSeedPhrases;
    }()
  }, {
    key: "getSeedPhrasesWithAccounts",
    value: function () {
      var _getSeedPhrasesWithAccounts = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var _this = this;

        var seedPhrases;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.getSeedPhrases();

              case 3:
                seedPhrases = _context6.sent;
                return _context6.abrupt("return", Promise.all(seedPhrases.map( /*#__PURE__*/function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(x) {
                    var suitableFormat;
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            suitableFormat = _this.seedPhraseFormats.find(function (y) {
                              return y.type === x.type;
                            });
                            _context5.t0 = _objectSpread;
                            _context5.t1 = _objectSpread({}, x);
                            _context5.t2 = {};
                            _context5.next = 6;
                            return suitableFormat.deriveKeysFromSeedPhrase(x);

                          case 6:
                            _context5.t3 = _context5.sent;
                            _context5.t4 = {
                              keys: _context5.t3
                            };
                            return _context5.abrupt("return", (0, _context5.t0)(_context5.t1, _context5.t2, _context5.t4));

                          case 9:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }())));

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", []);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function getSeedPhrasesWithAccounts() {
        return _getSeedPhrasesWithAccounts.apply(this, arguments);
      }

      return getSeedPhrasesWithAccounts;
    }()
  }, {
    key: "getAccounts",
    value: function () {
      var _getAccounts = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var _this2 = this;

        var seedPhrases, responses;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.getSeedPhrases();

              case 3:
                seedPhrases = _context8.sent;
                _context8.next = 6;
                return Promise.all(seedPhrases.map( /*#__PURE__*/function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(x) {
                    var suitableFormat;
                    return regenerator_default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            suitableFormat = _this2.seedPhraseFormats.find(function (y) {
                              return y.type === x.type;
                            });
                            return _context7.abrupt("return", suitableFormat.deriveKeysFromSeedPhrase(x));

                          case 2:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 6:
                responses = _context8.sent;
                return _context8.abrupt("return", responses.flatMap(function (x) {
                  return x;
                }));

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", []);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 10]]);
      }));

      function getAccounts() {
        return _getAccounts.apply(this, arguments);
      }

      return getAccounts;
    }()
  }]);

  return SeedPhraseModule;
}();

/* harmony default export */ var SeedPhrase = (SeedPhrase_SeedPhraseModule);
// CONCATENATED MODULE: ./index.ts




/***/ })
/******/ ]);